// import { useEffect, useState } from "react";
// import {
//   startSimulation,
//   pauseSimulation,
//   resumeSimulation,
//   stopSimulation,
//   getStatus
// } from "../api";
// import "./ControlPanel.css";
// import "./StatusPanel.css";

// export default function ControlPanel() {
//   const [matchId, setMatchId] = useState("");
//   const [intervalSec, setIntervalSec] = useState(20);
//   const [mode, setMode] = useState("events");
//   const [target, setTarget] = useState("both");
//   const [status, setStatus] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [pushMode, setPushMode] = useState("stream"); // stream | complete

//   useEffect(() => {
//     const timer = setInterval(async () => {
//       try {
//         const data = await getStatus();
//         setStatus(data);
//       } catch {}
//     }, 1000);

//     return () => clearInterval(timer);
//   }, []);

//   async function safeAction(fn) {
//     try {
//       setLoading(true);
//       await fn();
//     } finally {
//       setLoading(false);
//     }
//   }

//   async function handleStart() {
//     if (!matchId || intervalSec < 1) return;

//     setPushMode("stream");
//     await safeAction(() =>
//       startSimulation(matchId, intervalSec, mode, target, "stream")
//     );
//   }

//   async function handleCompletePush() {
//     if (!matchId) return;

//     setPushMode("complete");
//     await safeAction(() =>
//       startSimulation(matchId, 0, mode, target, "complete")
//     );
//   }

//   if (!status) return null;

//   const {
//     canStart,
//     canPause,
//     canResume,
//     canStop,
//     running,
//     paused,
//     currentEventIndex,
//     totalEvents,
//     matchId: activeMatchId,
//     mode: activeMode,
//     target: activeTarget
//   } = status;

//   const progress =
//     totalEvents > 0
//       ? (currentEventIndex / totalEvents) * 100
//       : 0;

//   return (
//     <div className="panel">
//       <h2>Match Simulator Admin</h2>

//       {/* CONTROLS */}
//       <div className="controls">
//         <div className="controls-row">
//           <input
//             type="number"
//             placeholder="Match ID"
//             value={matchId}
//             onChange={(e) => setMatchId(e.target.value)}
//             disabled={!canStart}
//           />

//           <input
//             type="number"
//             min="1"
//             placeholder="Interval (sec)"
//             value={intervalSec}
//             onChange={(e) => setIntervalSec(Number(e.target.value))}
//             disabled={!canStart || pushMode === "complete"}
//           />
//         </div>

//         <div className="controls-row">
//           <select
//             value={mode}
//             onChange={(e) => setMode(e.target.value)}
//             disabled={!canStart}
//           >
//             <option value="events">Match Events</option>
//             <option value="commentary">Match Commentary</option>
//             <option value="both">Events + Commentary</option>
//           </select>
//         </div>

//         <div className="controls-row">
//           <select
//             value={target}
//             onChange={(e) => setTarget(e.target.value)}
//             disabled={!canStart}
//           >
//             <option value="firebase">Firebase</option>
//             <option value="database">Database</option>
//             <option value="both">Firebase + Database</option>
//           </select>
//         </div>
//       </div>

//       {/* ACTION BUTTONS */}
//       <div className="buttons">
//         <button
//           className="btn-start"
//           onClick={handleStart}
//           disabled={!canStart || loading}
//         >
//           ▶ Start
//         </button>

//         <button
//           className="btn-complete"
//           onClick={handleCompletePush}
//           disabled={!canStart || loading}
//         >
//           🚀 Complete Data Push
//         </button>

//         <button
//           className="btn-pause"
//           onClick={() => safeAction(pauseSimulation)}
//           disabled={!canPause || loading || pushMode === "complete"}
//         >
//           ⏸ Pause
//         </button>

//         <button
//           className="btn-resume"
//           onClick={() => safeAction(resumeSimulation)}
//           disabled={!canResume || loading || pushMode === "complete"}
//         >
//           ▶ Resume
//         </button>

//         <button
//           className="btn-stop"
//           onClick={() => safeAction(stopSimulation)}
//           disabled={!canStop || loading}
//         >
//           🛑 Stop
//         </button>
//       </div>

//       {/* STATUS */}
//       <div className="status-panel" style={{ marginTop: 20 }}>
//         <h3>Simulation Status</h3>

//         <div className="status-row state">
//           <span
//             className={`state-dot ${
//               running
//                 ? paused
//                   ? "state-paused"
//                   : "state-running"
//                 : "state-stopped"
//             }`}
//           />
//           <span>
//             {running
//               ? paused
//                 ? "PAUSED"
//                 : pushMode === "complete"
//                 ? "COMPLETE PUSH"
//                 : "RUNNING"
//               : "STOPPED"}
//           </span>
//         </div>

//         <hr className="divider desktop" />

//         <div className="status-row">
//           <strong>Match ID:</strong> {activeMatchId ?? "—"}
//         </div>

//         <div className="status-row">
//           <strong>Mode:</strong>{" "}
//           {pushMode === "complete"
//             ? "Complete Data Push"
//             : activeMode === "both"
//             ? "Events + Commentary"
//             : activeMode || "—"}
//         </div>

//         <div className="status-row">
//           <strong>Target:</strong>{" "}
//           {activeTarget === "both"
//             ? "Firebase + Database"
//             : activeTarget || "—"}
//         </div>

//         {/* 🔥 STREAM-ONLY PROGRESS */}
//         {pushMode === "stream" && (
//           <>
//             <div className="status-row">
//               <strong>Progress:</strong>{" "}
//               {currentEventIndex} / {totalEvents}
//             </div>

//             <div className="progress-wrap">
//               <div className="progress-bar">
//                 <div
//                   className="progress-fill"
//                   style={{ width: `${progress}%` }}
//                 />
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }



import { useEffect, useState, useCallback } from "react";
import {
  startSimulation,
  pauseSimulation,
  resumeSimulation,
  stopSimulation,
  getStatus
} from "../api";
import "./ControlPanel.css";
import "./StatusPanel.css";

/**
 * ERROR NORMALIZER
 */
function normalizeError(message = "") {
  const msg = message.toLowerCase();

  if (
    msg.includes("unauthorized") ||
    msg.includes("credential") ||
    msg.includes("oval")
  ) {
    return "Oval credentials are invalid, contact developer to get updated creds";
  }

if (msg.includes("valid match-id")) {
  return "Please enter a valid match-id";
}

if (msg.includes("match") && msg.includes("invalid")) {
  return "Please enter a valid match-id";
}

if (msg.includes("not found")) {
  return "Please enter a valid match-id";
}


  return message || "Something went wrong. Please try again.";
}

/**
 * SINGLE SIMULATOR CARD
 */
function SimulatorCard({
  simulator,
  backendStatus,
  onUpdate,
  onStart,
  onComplete,
  onPause,
  onResume,
  onStop,
  onRemove
}) {
  const simStatus = backendStatus.simulators.find(
    (s) => s.simulatorId === simulator.simulatorId
  );

  const running = Boolean(simStatus);
  const paused = simStatus?.paused ?? false;
  const current = simStatus?.currentEventIndex ?? 0;
  const total = simStatus?.totalEvents ?? 0;
  const progress = total > 0 ? (current / total) * 100 : 0;

  /**
   * ✅ COMPLETE PUSH FINISH HANDLER (ONCE)
   */
  useEffect(() => {
    if (
      simulator.pushMode === "complete" &&
      simulator.simulatorId &&
      !simStatus &&
      !simulator.completed
    ) {
      onUpdate(simulator.uiId, {
        simulatorId: null,
        completed: true
      });
    }
  }, [
    simulator.pushMode,
    simulator.simulatorId,
    simulator.completed,
    simulator.uiId,
    simStatus,
    onUpdate
  ]);

  /**
   * RUNTIME STATUS (DERIVED)
   */
  let runtimeStatus = "IDLE";
  if (running) {
    if (paused) runtimeStatus = "PAUSED";
    else if (simulator.pushMode === "complete") runtimeStatus = "COMPLETE PUSH";
    else runtimeStatus = "RUNNING";
  } else if (simulator.completed) {
    runtimeStatus = "COMPLETED";
  }

  return (
    <div className="panel">
      <h2>Match Simulator</h2>

      {/* INPUTS */}
      <div className="controls">
        <div className="controls-row">
          <input
            type="number"
            placeholder="Match ID"
            value={simulator.matchId}
            onChange={(e) =>
              onUpdate(simulator.uiId, {
                matchId: e.target.value,
                error: null
              })
            }
            disabled={running}
          />

          <input
            type="number"
            min="1"
            placeholder="Interval (sec)"
            value={simulator.intervalSec}
            onChange={(e) =>
              onUpdate(simulator.uiId, {
                intervalSec: Number(e.target.value),
                error: null
              })
            }
            disabled={running}
          />
        </div>

        <div className="controls-row">
          <select
            value={simulator.mode}
            onChange={(e) =>
              onUpdate(simulator.uiId, { mode: e.target.value, error: null })
            }
            disabled={running}
          >
            <option value="events">Match Events</option>
            <option value="commentary">Match Commentary</option>
            <option value="both">Events + Commentary</option>
          </select>
        </div>

        <div className="controls-row">
          <select
            value={simulator.target}
            onChange={(e) =>
              onUpdate(simulator.uiId, { target: e.target.value, error: null })
            }
            disabled={running}
          >
            <option value="firebase">Firebase</option>
            <option value="database">Database</option>
            <option value="both">Firebase + Database</option>
          </select>
        </div>
      </div>

      {/* ACTIONS */}
      <div className="buttons">
        <button
          className="btn-start"
          disabled={running}
          onClick={() => onStart(simulator.uiId)}
        >
          ▶ Start
        </button>

        <button
          className="btn-complete"
          disabled={running}
          onClick={() => onComplete(simulator.uiId)}
        >
          🚀 Complete Push
        </button>

        <button
          className="btn-pause"
          disabled={!running || paused || simulator.pushMode === "complete"}
          onClick={() => onPause(simulator.simulatorId)}
        >
          ⏸ Pause
        </button>

        <button
          className="btn-resume"
          disabled={!running || !paused || simulator.pushMode === "complete"}
          onClick={() => onResume(simulator.simulatorId)}
        >
          ▶ Resume
        </button>

        <button
          className="btn-stop"
          disabled={!running}
          onClick={() => onStop(simulator.simulatorId)}
        >
          🛑 Stop
        </button>

        <button className="btn-remove" onClick={() => onRemove(simulator)}>
          🗑 Remove
        </button>
      </div>

      {/* VALIDATION ERROR */}
      {simulator.error && (
        <div className="validation-error">
          ⚠ {simulator.error}
        </div>
      )}

      {/* STATUS */}
      <div className="status-panel">
        <div className="status-row">
          <strong>Status:</strong> {runtimeStatus}
        </div>

        {simulator.pushMode === "stream" && running && (
          <>
            <div className="status-row">
              <strong>Progress:</strong> {current} / {total}
            </div>

            <div className="progress-wrap">
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/**
 * CONTROL PANEL
 */
export default function ControlPanel() {
  const [simulators, setSimulators] = useState([
    {
      uiId: Date.now(),
      simulatorId: null,
      matchId: "",
      intervalSec: 20,
      mode: "events",
      target: "both",
      pushMode: "stream",
      completed: false,
      error: null
    }
  ]);

  const [status, setStatus] = useState({ simulators: [] });

  useEffect(() => {
    const timer = setInterval(async () => {
      const data = await getStatus();
      if (data) setStatus(data);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const updateSimulator = useCallback((uiId, patch) => {
    setSimulators((prev) =>
      prev.map((s) => (s.uiId === uiId ? { ...s, ...patch } : s))
    );
  }, []);

  function addSimulator() {
    setSimulators((prev) => [
      ...prev,
      {
        uiId: Date.now(),
        simulatorId: null,
        matchId: "",
        intervalSec: 20,
        mode: "events",
        target: "both",
        pushMode: "stream",
        completed: false,
        error: null
      }
    ]);
  }

  async function startCard(uiId) {
    const s = simulators.find((x) => x.uiId === uiId);
  if (!s?.matchId) {
  updateSimulator(uiId, {
    error: "Please enter a Match ID"
  });
  return;
}


    try {
      const res = await startSimulation({
        matchId: s.matchId,
        interval: s.intervalSec,
        mode: s.mode,
        target: s.target,
        pushMode: "stream"
      });

      updateSimulator(uiId, {
        simulatorId: res.simulatorId,
        pushMode: "stream",
        completed: false,
        error: null
      });
    } catch (err) {
      updateSimulator(uiId, {
        error: normalizeError(err.message)
      });
    }
  }

  async function completeCard(uiId) {
    const s = simulators.find((x) => x.uiId === uiId);
   if (!s?.matchId) {
  updateSimulator(uiId, {
    error: "Please enter a Match ID"
  });
  return;
}


    try {
      const res = await startSimulation({
        matchId: s.matchId,
        interval: 0,
        mode: s.mode,
        target: s.target,
        pushMode: "complete"
      });

      updateSimulator(uiId, {
        simulatorId: res.simulatorId,
        pushMode: "complete",
        completed: false,
        error: null
      });
    } catch (err) {
      updateSimulator(uiId, {
        error: normalizeError(err.message)
      });
    }
  }

  async function removeCard(sim) {
    if (sim.simulatorId) {
      await stopSimulation(sim.simulatorId);
    }
    setSimulators((prev) =>
      prev.filter((s) => s.uiId !== sim.uiId)
    );
  }

  return (
    <div className="simulator-wrapper">
      <div className="simulator-header">
        <div
          className="add-simulator"
          onClick={addSimulator}
          title="Add Simulator"
        >
          +
        </div>
      </div>

      <div className="simulator-grid">
        {simulators.map((sim) => (
          <SimulatorCard
            key={sim.uiId}
            simulator={sim}
            backendStatus={status}
            onUpdate={updateSimulator}
            onStart={startCard}
            onComplete={completeCard}
            onPause={pauseSimulation}
            onResume={resumeSimulation}
            onStop={stopSimulation}
            onRemove={removeCard}
          />
        ))}
      </div>
    </div>
  );
}
